// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const smoliv: PokeData = {
  "id": 928,
  "name": "smoliv",
  "height": 3,
  "weight": 65,
  "base_experience": 52,
  "types": [
    PokeType.GRASS,
    PokeType.NORMAL
  ],
  "api_moves": [
    "tackle",
    "absorb",
    "mega-drain",
    "leech-seed",
    "growth",
    "razor-leaf",
    "flail",
    "sweet-scent",
    "helping-hand",
    "seed-bomb",
    "energy-ball",
    "grassy-terrain",
    "terrain-pulse"
  ],
  "moves": [
    "tackle",
    "razor-leaf",
    "energy-ball",
    "grassy-terrain",
    "aromatherapy",
    "protect",
    "scary-face",
    "quick-attack",
    "scratch",
    "purification",
    "overgrowth",
    "vine-whip",
    "headbutt"
  ],
  "evolution_chain": {
    "id": 487,
    "item": null,
    "species": [
      {
        "name": "smoliv",
        "order": 935,
        "types": [
          PokeType.GRASS,
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "dolliv",
        "order": 936,
        "types": [
          PokeType.GRASS,
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 928,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 25,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "arboliva",
        "order": 937,
        "types": [
          PokeType.GRASS,
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 929,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 44.5,
    "speed": 30,
    "ability_power": 58
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
